export type AuditRating = {
  categoryId: string;
  paramDefinitionId: string;
  name?: string;
};
